// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner_spinner_container__viXUz {
    width: 100%;
    display: flex;
    min-height: 20vh;
    align-items: center;
    justify-content: center;
    background-color: #191A17;
}

.spinner_spinner__kbL3E {
    display: flex;
    gap: 0.8rem;
    align-items: center;
}

.spinner_spinner_circle__p\\+ltF {
    width: 1rem;
    height: 1rem;
    background: linear-gradient(135deg, #D6E5B8, #ADB2A1);
    border-radius: 50%;
    animation: spinner_bounce__5tczf 1.4s infinite ease-in-out;
    box-shadow: 0 0 15px rgba(214, 229, 184, 0.4);
}

.spinner_spinner_circle__p\\+ltF:nth-child(1) {
    animation-delay: -0.32s;
}

.spinner_spinner_circle__p\\+ltF:nth-child(2) {
    animation-delay: -0.16s;
    background: linear-gradient(135deg, #ADB2A1, #7B8073);
}

.spinner_spinner_circle__p\\+ltF:nth-child(3) {
    animation-delay: 0s;
}

@keyframes spinner_bounce__5tczf {
    0%, 80%, 100% {
        transform: scale(0.7) translateY(0);
        opacity: 0.6;
    }
    40% {
        transform: scale(1.2) translateY(-20px);
        opacity: 1;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/spinner-bar/spinner.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,kBAAkB;IAClB,0DAA2C;IAC3C,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mCAAmC;QACnC,YAAY;IAChB;IACA;QACI,uCAAuC;QACvC,UAAU;IACd;AACJ","sourcesContent":[".spinner_container {\r\n    width: 100%;\r\n    display: flex;\r\n    min-height: 20vh;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #191A17;\r\n}\r\n\r\n.spinner {\r\n    display: flex;\r\n    gap: 0.8rem;\r\n    align-items: center;\r\n}\r\n\r\n.spinner_circle {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    background: linear-gradient(135deg, #D6E5B8, #ADB2A1);\r\n    border-radius: 50%;\r\n    animation: bounce 1.4s infinite ease-in-out;\r\n    box-shadow: 0 0 15px rgba(214, 229, 184, 0.4);\r\n}\r\n\r\n.spinner_circle:nth-child(1) {\r\n    animation-delay: -0.32s;\r\n}\r\n\r\n.spinner_circle:nth-child(2) {\r\n    animation-delay: -0.16s;\r\n    background: linear-gradient(135deg, #ADB2A1, #7B8073);\r\n}\r\n\r\n.spinner_circle:nth-child(3) {\r\n    animation-delay: 0s;\r\n}\r\n\r\n@keyframes bounce {\r\n    0%, 80%, 100% {\r\n        transform: scale(0.7) translateY(0);\r\n        opacity: 0.6;\r\n    }\r\n    40% {\r\n        transform: scale(1.2) translateY(-20px);\r\n        opacity: 1;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner_container": `spinner_spinner_container__viXUz`,
	"spinner": `spinner_spinner__kbL3E`,
	"spinner_circle": `spinner_spinner_circle__p+ltF`,
	"bounce": `spinner_bounce__5tczf`
};
export default ___CSS_LOADER_EXPORT___;
